var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contentMain"},[_c('div',{staticClass:"content"},[_c('div',[_vm._v("中国铁道工程建设协会团体标准立项申请书")]),_c('a',{attrs:{"href":"https://carec.oss-cn-beijing.aliyuncs.com/upload/2024/01/29/e1b0ad23-a422-4b4d-bf2c-24486a3a2651.doc"}},[_vm._v("下载")])])])
}]

export { render, staticRenderFns }